/* eslint-disable consistent-return */
import { APPOINTMENT_ENTRY } from "../../../contants/formFields";

export const formValidate = (
  values,
  structureChiefIds,
  { isDistrictSi, isChapterSi, isRegionSi, isZoneSi, isAreaSi }
) => {
  // const { dateOfJoining } = memberDetails;
  // const year = dateOfJoining.slice(0, 4);

  // const durationOfPractice = () => {
  //   const participationYear = values[APPOINTMENT_ENTRY.PARTICIPATION_YEAR];

  //   const getDuration = participationYear - year;

  //   return getDuration;
  // };

  // const totalPractice = durationOfPractice();
  // console.log("122", totalPractice);

  const otherLeaderInputValidation = {
    isRegionSi,
    isZoneSi,
    isAreaSi,
  };
  // if (!values[APPOINTMENT_ENTRY.NUMBER_OF_SHAKUBUL]) {
  //   return "Please enter Number of Shakubuku";
  // }

  if (
    values[APPOINTMENT_ENTRY.NUMBER_OF_SHAKUBUL] === null ||
    values[APPOINTMENT_ENTRY.NUMBER_OF_SHAKUBUL] === undefined
  ) {
    return "Please enter Number of Shakubuku";
  }

  // if (!values[APPOINTMENT_ENTRY.NO_OF_HOME_VISITS_WEEK]) {
  //   return "Please enter Number of Home Visits Week";
  // }

  if (
    values[APPOINTMENT_ENTRY.NO_OF_HOME_VISITS_WEEK] === null ||
    values[APPOINTMENT_ENTRY.NO_OF_HOME_VISITS_WEEK] === undefined
  ) {
    return "Please enter Number of Home Visits Week";
  }

  // if (!values[APPOINTMENT_ENTRY.IS_PROG_ATTENDED]) {
  //   return "Please enter SGI TRG CRS/ BSG DAISEIDO TRG PROG. attended";
  // }
  if (
    values[APPOINTMENT_ENTRY.IS_PROG_ATTENDED] === "YES" &&
    !values[APPOINTMENT_ENTRY.PARTICIPATION_YEAR]
  ) {
    return "Please enter Year of Last Participation";
  }
  // if (String(values[APPOINTMENT_ENTRY.PARTICIPATION_YEAR]) < year) {
  //   return "Year of Last Participation is lesser than Date of Joining";
  // }
  if (isDistrictSi) {
    // if (!values[APPOINTMENT_ENTRY.VC_SUBSCRIPTION]) {
    //   return "Please enter VC Subscription";
    // }
    if (!values[APPOINTMENT_ENTRY.DOING_GONGYO_AND_DAIKOMU]) {
      return "Please enter doing Gongyo & Daimoku regularly";
    }
    // if (values[APPOINTMENT_ENTRY.DOING_GONGYO_AND_DAIKOMU] > totalPractice) {
    //   return "Please enter valid doing Gongyo & Daimoku regularly";
    // }
    // if (!values[APPOINTMENT_ENTRY.POSITION_HELD_IN_YOUTH_DIVISION]) {
    //   return "Please enter Position held in Youth Division";
    // }
  } else if (isChapterSi) {
    if (!values[APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE]) {
      return "Please enter years of active participation";
    }
    // if (values[APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE] > totalPractice) {
    //   return "Years of active participation are not valid";
    // }
    if (!values[APPOINTMENT_ENTRY.HAS_BEEN_BLOCK_CHEIF]) {
      return "Please enter Has been Block Chief";
    }
    if (!values[APPOINTMENT_ENTRY.ATTENDING_MEETING]) {
      return "Please enter Attending Meeting";
    }
    // if (!values[APPOINTMENT_ENTRY.POSITION_HELD_IN_YOUTH_DIVISION]) {
    //   return "Please enter Position held in Youth Division";
    // }
  } else if (Object.values(otherLeaderInputValidation).find((si) => si)) {
    // if (!values[APPOINTMENT_ENTRY.VC_SUBSCRIPTION]) {
    //   return "Please enter VC Subscription";
    // }
    if (!values[APPOINTMENT_ENTRY.MADE_EFFORTS_TOWARDS]) {
      return "Please enter efforts toward Fostering capable leaders";
    }
    if (!values[APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE]) {
      return "Please enter years of active participation";
    }
    // if (values[APPOINTMENT_ENTRY.YEARS_OF_ACTIVE_PRACTICE] > totalPractice) {
    //   return "Years of active participation are not valid";
    // }
  }
  if (isZoneSi) {
    if (!values[APPOINTMENT_ENTRY.HAS_BEEN_CHAPTER_CHEIF]) {
      return "Please select 1 year should be main CC not Deputy";
    }
    if (!values[APPOINTMENT_ENTRY.ATTENDING_BSG_MEETING_INCLUDING_NHR_GOSHO]) {
      return "Please enter Regularly Attending BSG Meetings Including NHR/GOSHO Study Meeting";
    }
    if (!values[APPOINTMENT_ENTRY.ACTIVELY_PARTICIPATING_LEADER_MEETING]) {
      return "Please enter actively participating in Leader and taking monthly Gosho Meeting";
    }
    if (
      !values[
        APPOINTMENT_ENTRY
          .CLEARED_THE_INTRODUCTORY_LEVEL_EXAMINATION_ENTRANCE_EXAM
      ]
    ) {
      return "Please enter Cleared the Introductory Level Examination";
    }
    if (!values[APPOINTMENT_ENTRY.OWN_GOHONZON_OR_FAMILY_GOHONZON]) {
      return "Please enter Own or Family Gohonzon Details";
    }
  }
  if (isAreaSi) {
    if (!values[APPOINTMENT_ENTRY.HAS_BEEN_REGION_CHEIF]) {
      return "Please enter Has been Region Chief";
    }
    if (!values[APPOINTMENT_ENTRY.ACTIVELY_SUPPORTING_LEADERS_MEETING]) {
      return "Please enter Actively supporting Leaders Meeting";
    }
    if (!values[APPOINTMENT_ENTRY.CLEARED_THE_INTRODUCTORY_LEVEL_EXAMINATION]) {
      return "Please enter Cleared the Introductory Level Examination";
    }
  }
  if (structureChiefIds.length === 0) {
    return "Please select recommended by";
  }
  return "";
};

export const interviwerValidation = (ids) => {
  if (!ids || !ids.length) return "Please select at least one interviewer";
};
